const bulkUploadTabs = {
  DOCUMENT_UPLOAD: "Document Upload",
  BULK_UPLOAD_STATUS_HISTORY: "Bulk Upload Status history",
};

export { bulkUploadTabs };
